import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Loader from './components/ui/Loader';
import ScrollToTop from './components/ui/ScrollToTop';

import Home from './pages/Home';
import AboutSchool from './pages/AboutSchool';
import PrincipalMessage from './pages/PrincipalMessage';
import ChairmanMessage from './pages/ChairmanMessage';
import ManagerMessage from './pages/ManagerMessage';
import AcademicCalendar from './pages/AcademicCalendar';
import Syllabus from './pages/Syllabus';
import TimeTable from './pages/TimeTable';
import ContactUs from './pages/ContactUs';
import Login from './pages/Login';
import GalleryAll from './pages/GalleryAll';
import SingleGalleryAlbum from './pages/SingleGalleryAlbum';
import VideoGalleryAll from './pages/VideoGalleryAll';
import SingleVideoGallery from './pages/SingleVideoGallery';
import NormalNoticeAll from './pages/NormalNoticeAll';
import SingleNotice from './pages/SingleNotice';
import PublicDisclosure from './pages/PublicDisclosure';
import CbseMandatoryDisclosure from './pages/CbseMandatoryDisclosure';
import NotFound from './pages/NotFound';

import './App.css';

export default function App() {
  return (
    <>
      <Loader />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-school" element={<AboutSchool />} />
        <Route path="/principal-message" element={<PrincipalMessage />} />
        <Route path="/chairman-message" element={<ChairmanMessage />} />
        <Route path="/manager-message" element={<ManagerMessage />} />
        <Route path="/academic-calendar" element={<AcademicCalendar />} />
        <Route path="/syllabus" element={<Syllabus />} />
        <Route path="/time-table" element={<TimeTable />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/noticeall" element={<NormalNoticeAll />} />
        <Route path="/notice/:noticeId" element={<SingleNotice />} />
        <Route path="/galleryall" element={<GalleryAll />} />
        <Route path="/gallery/:galleryId" element={<SingleGalleryAlbum />} />
        <Route path="/videoall" element={<VideoGalleryAll />} />
        <Route path="/video/:videoId" element={<SingleVideoGallery />} />
        <Route path="/public-disclosure" element={<PublicDisclosure />} />
        <Route path="/cbse-mandatory-public-disclosure" element={<CbseMandatoryDisclosure />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}
